import { atom } from "recoil";

export const atom_scrollTarget = atom<string | null>({
    key: "ScrollTarget",
    default: null,
});

export const atom_scrollY = atom<number>({
    key: "ScrollY",
    default: 0,
});

// Store reference to the scrollable modal container
export const atom_scrollContainerRef = atom<HTMLElement | null>({
    key: "ScrollContainerRef",
    default: null,
    dangerouslyAllowMutability: true, // Refs are mutable by nature
});